import apiSlice from "../api/apiSlice";

export const ewhApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    /* GET */
    getEWHUsageByCommunityIdPagination: builder.query({
      query: ({ limit, page, date, time, resourceId, communityId, sortColumn, sortDirection }) => ({
        url:
          `/communities/${communityId}/ewh_usage/pagination?` +
          `limit=${limit}&` +
          `offset=${page * limit}` +
          `${date ? `&date=${date}` : ""}` +
          `${time ? `&time=${time}` : ""}` +
          `${resourceId ? `&resource_id=${resourceId}` : ""}` +
          `${sortDirection ? `&sort_direction=${sortDirection}` : ""}` +
          `${sortColumn ? `&sort_column=${sortColumn}` : ""}`,
        method: "GET",
      }),
      providesTags: () => [{ type: "EWH", id: "LIST" }],
    }),
    addEWHUsage: builder.mutation({
      query: ({ file, communityId }) => {
        const formData = new FormData();

        formData.append("file_upload", file, file.name);

        return {
          url: `/communities/${communityId}/ewh_usage`,
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: [{ type: "EWH", id: "LIST" }],
    }),
  }),
});

export const { useAddEWHUsageMutation, useGetEWHUsageByCommunityIdPaginationQuery } = ewhApiSlice;
